/** Input types a person types into, where the browser's own Ctrl+Z and the like apply. */
const NOT_TYPED = new Set([
  'checkbox',
  'radio',
  'button',
  'submit',
  'reset',
  'range',
  'color',
  'file',
]);

/** Whether a key press is typing into a field, which keeps the browser's own shortcuts. */
export function typingInField(target: EventTarget | null): boolean {
  const element = target as { tagName?: string; type?: string; isContentEditable?: boolean } | null;
  if (!element?.tagName) return false;
  if (element.isContentEditable || element.tagName === 'TEXTAREA') return true;
  return element.tagName === 'INPUT' && !NOT_TYPED.has(element.type ?? 'text');
}

type ShortcutEvent = Pick<
  KeyboardEvent,
  'key' | 'ctrlKey' | 'metaKey' | 'altKey' | 'shiftKey' | 'target'
>;

/**
 * The editor's shortcut a key press asks for (editor:quality#14): Ctrl+Z undoes, Ctrl+Shift+Z or
 * Ctrl+Y redoes, Ctrl+S saves; Cmd for Ctrl on a Mac. None while typing into a field.
 */
export function editorShortcut(e: ShortcutEvent): 'undo' | 'redo' | 'save' | null {
  if (!(e.ctrlKey || e.metaKey) || e.altKey || typingInField(e.target)) return null;
  const key = e.key.toLowerCase();
  if (key === 'z') return e.shiftKey ? 'redo' : 'undo';
  if (key === 'y') return 'redo';
  if (key === 's') return 'save';
  return null;
}
